module.exports = __webpack_public_path__ + "static/img/preview.13c27af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/time-hollow-banner-campaign/preview.png
// module id = 115
// module chunks = 2